import { render, staticRenderFns } from "./tourist-list.vue?vue&type=template&id=2faa9bec&scoped=true&"
import script from "./tourist-list.vue?vue&type=script&lang=js&"
export * from "./tourist-list.vue?vue&type=script&lang=js&"
import style0 from "./tourist-list.vue?vue&type=style&index=0&id=2faa9bec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2faa9bec",
  null
  
)

export default component.exports